<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="5"></ucMenu>
					<div class="right_con">
						<div class="shangjia_main">
							<p class="fb">售后地址</p>
							<div class="opts_wrap">
								<el-form ref="form" :model="form" label-width="100px"	v-loading="loading">
								  <el-form-item label="收货人">
								    <el-input v-model="form.name" placeholder="请输入收件人姓名"></el-input>
								  </el-form-item>
								  <el-form-item label="手机号">
								    <el-input v-model="form.phone" placeholder="请输入收件人手机号"></el-input>
								  </el-form-item>
								  <el-form-item label="省市区">
								    <el-cascader
											placeholder="请输入省市区"
								    	size="large"
											style="width: 100%;"
								    	:options="regionData"
								    	v-model="selectedOptions"
								    	:props="regionProps"
								    	@change="areaChange">
								    </el-cascader>
								  </el-form-item>
								  <el-form-item label="详细地址">
								    <el-input type="textarea"  v-model="form.detail" placeholder="请输入详细地址"></el-input>
								  </el-form-item>

								</el-form>
								<div class="btn_wrap">
									<p class="btn" @click="submitForm()">提交</p>
									<p class="btn" @click="resetForm()">重置</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		mapActions,
		mapState
	} from "vuex";
	import myHead from '../../components/myHead/myhead';
	import myFoot from '../../components/myFoot/myfoot';
	import ucMenu from '../../components/ucenterMenu/ucmenu';

	export default {
		name: "ucenterAfterSaleAddress",
		data() {
			return {
				address_text: '',
				form:{
					type: 2,//1:发货地址 2:售后地址
					province_id:'',
					city_id:'',
					town_id:'',
					street_id:'',
					detail:'',
					name:'',
					phone:'',
				},
				regionData: [],
				regionProps:{
					value:'id',
					label:'label'
				},
				selectedOptions: [],
				// 加载状态
				loading: false
			}
		},
		components: {
			myHead,
			myFoot,
			ucMenu,
		},
		computed: {
			...mapState({

			})
		},
		created() {
			this.initRegionData();
		},
		methods: {
			...mapActions({
				getRegionData:"ucenter_order/getRegionData",
				getBusinessAddressInfo:"ucenter_order/getBusinessAddressInfo",
				opEditBusinessAddress:"ucenter_order/opEditBusinessAddress",
			}),
			initRegionData(){
				var params = {}
				this.loading = true
				this.getRegionData({data:params,success:(res)=>{
					if(res.code===200){
						this.regionData = res.data
						this.initBusinessAddressInfo()
					} else {
						this.loading = false
						this.$message({message: res.msg,type: 'error',});
					}
				}})
			},
			initBusinessAddressInfo(){
				const params = { type: this.form.type }
				this.getBusinessAddressInfo({data:params,success:(res)=>{
					this.loading = false
					if(res.code===200){
						const address = res.data || {}
						this.form = {
							...this.form,
							...address,
							type: this.form.type
						}
						const areaIds = [address.province_id, address.city_id, address.town_id, address.street_id]
							.filter(item => item !== undefined && item !== null && item !== '')
							.map(item => Number(item))
						this.selectedOptions = areaIds
					} else {
						this.$message({message: res.msg,type: 'error',});
					}
				}})
			},
			areaChange(value) {
				this.form.province_id = value && value[0] ? value[0] : ''
				this.form.city_id = value && value[1] ? value[1] : ''
				this.form.town_id = value && value[2] ? value[2] : ''
				this.form.street_id = value && value[3] ? value[3] : ''
			},
			// 提交表单
			submitForm() {
				if (!this.form.name) {
					this.$message.error('请输入收件人姓名');
					return;
				}
				if (!this.form.phone) {
					this.$message.error('请输入收件人手机号');
					return;
				}
				if (!/^1\d{10}$/.test(this.form.phone)) {
					this.$message.error('请输入正确的手机号');
					return;
				}
				if (!this.form.province_id || !this.form.city_id || !this.form.town_id) {
					this.$message.error('请选择省市区');
					return;
				}
				if (!this.form.detail) {
					this.$message.error('请输入详细地址');
					return;
				}

				const params = {
					...this.form,
					type: 2
				}
				this.loading = true
				this.opEditBusinessAddress({
					data: params,
					success: (res) => {
						this.loading = false
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: 'success',
							});
							this.initBusinessAddressInfo()
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
							});
						}
					}
				})
			},
			// 重置表单
			resetForm() {
				this.initBusinessAddressInfo()
			},
		},
	}
</script>

<style  scoped>
	.wrap .wrap_body {
		display: flex;
		flex-direction: column;
	}

	.center {
		display: flex;
		flex: 1;
	}

	.shangjia_main {
		padding: 36px 40px;
		background: #fff;
	}

	.opts_wrap {
		margin-left: 50px;
		padding-top: 14px;
    width: 40%;
    min-width: 500px;
	}

	.opts_wrap .opts_line {
		margin-top: 30px;
		display: flex;
		align-items: center;
	}

	.opts_line .txt {
		width: 140px;
		text-align: right;
		font-size: 14px;
	}
	.opts_line .txt.txt_check {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.opts_line .con {
		flex: 1;
		width: 0;
		margin-left: 22px;
		display: flex;
		align-items: center;
	}

	.opts_line .con .t {
		font-size: 14px;
	}

	.opts_wrap .btn_wrap {
		margin: 40px 0 0 112px;
		display: flex;
	}

	.opts_wrap .btn_wrap .btn {
		width: 80px;
		height: 34px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 14px;
		cursor: pointer;
		box-sizing: border-box;
		font-size: 14px;
	}

	.opts_wrap .btn_wrap .btn:nth-child(1) {
		background: var(--red);
		color: #fff;
	}

	.opts_wrap .btn_wrap .btn:nth-child(2) {
		background: #fff;
		color: #333;
		border: 1px solid #ddd;
	}

	.ml8 {
		margin-left: 8px;
	}

	.w80 {
		width: 80px;
	}

</style>
<style scoped>
	/*red border color*/
	.el-input__inner:focus,
	.el-select .el-input.is-focus .el-input__inner,
	.el-select .el-input__inner:focus,
	.el-radio__input.is-checked .el-radio__inner,
	.el-radio__inner:hover {
		border-color: var(--red);
	}

	/*red color*/
	.el-select-dropdown__item.selected,
	.el-radio__input.is-checked+.el-radio__label {
		color: var(--red);
	}

	/*red background color*/
	.el-radio__input.is-checked .el-radio__inner {
		background-color: var(--red);
	}
</style>
